const toKebabCase = (text) =>
  text?.trim().toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "");

export const transformStrategyData = (data) =>
  data.map((strategy) => ({
    idStrategy: strategy.strategyId,
    slug: strategy.metadata?.slug ?? strategy.slug,
    ownerSlug: toKebabCase(strategy.owner?.name),
    title: strategy.strategyName,
    description: strategy.description || "No description available.",
    chartData: (strategy.slices || []).map((slice) => ({
      date: slice.date,
      value: slice.normalizedNetNav,
      displayPercent: slice.displayPercent,
    })),
    periodReturn: strategy.netNav ?? 0,
    tags: strategy.metadata?.tags,
    categories: strategy.metadata?.categories,
    sharpeRatio: strategy.sharpeRatio || 0,
    annualizedReturn: strategy.annualizedReturn ?? null,
    sortinoRatio: strategy.sortinoRatio ?? null,
    twr: strategy.twr ?? null,
    relativeReturn: strategy.relativeReturn ?? null,
    maxDrawdown: strategy.maxDrawdown ?? null,
    owner: strategy.owner || null,
    startDate: strategy.startDate,
    endDate: strategy.endDate,
  }));

export const withPeriodCached = (strategy, period) => ({
  ...strategy,
  fetchedPeriods: {
    [period]: { chartData: strategy.chartData, periodReturn: strategy.periodReturn, relativeReturn: strategy.relativeReturn },
  },
});

export const applyPeriod = (strategy, period) => {
  const periodData = strategy.fetchedPeriods[period];
  return { ...strategy, chartData: periodData.chartData, periodReturn: periodData.periodReturn, relativeReturn: periodData.relativeReturn };
};

export const storePeriod = (strategy, period, freshData) => ({
  ...strategy,
  chartData: freshData.chartData,
  periodReturn: freshData.periodReturn,
  relativeReturn: freshData.relativeReturn,
  fetchedPeriods: {
    ...strategy.fetchedPeriods,
    [period]: { chartData: freshData.chartData, periodReturn: freshData.periodReturn, relativeReturn: freshData.relativeReturn },
  },
});
